import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { EnvService } from "../services/env.service";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "micro-disk-profile-detail",
  templateUrl: "./cmdb-disk-profile-detail.component.html",
})
export class CmdbDiskProfileDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() diskProfileId: any;
  @Output() persisted = new EventEmitter<any>();
  diskProfile: any;

  hostingPlatformName: any = "";
  selectedHostingPlatform: any;

  osVersionName: any = "";
  selectedOsVersion: any;

  osDiskTypeName: any = "";
  selectedOsDiskType: any;

  osMountName: any = "";
  selectedOsMount: any;

  storageTierName: any = "";
  selectedStorageTier: any;

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.diskProfileId) {
      this.load(this.diskProfileId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.http
      .get(`${this.env.e.url}/domain/cmdbDiskProfiles/${id}`)
      .subscribe((data) => {
        this.diskProfile = data;
      });
  }

  createNew(): void {
    // TODO: This is a hack to get the form to work with a new object.  We should refactor the form to not require an id for a new object.
    this.diskProfile = {
      code: "",
      name: "",
      description: "",
      active: "Y",
      templateId: "",
      platformId: "",
      osVersionId: "",
      osDefaultDiskSize: 0,
      minGB: 0,
      maxGB: 0,
      osDiskType: "",
      osMount: "",
      Reason: "",
      maxAdditionalDisks: 0,
      maxTotalDisks: 0,
      storageTierId: "",
      encryptionMandatory: "N",
      engineerAdd: "N",
      engineerResize: "N",
      notes: "",
      companyId: this.auth.getCompanyId(),
    };
  }

  save(): void {
    const isUpdate = !!this.diskProfile.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/domain/cmdbDiskProfiles/${this.diskProfile.id}`,
          this.diskProfile,
        )
      : this.http.post(
          `${this.env.e.url}/domain/cmdbDiskProfiles`,
          this.diskProfile,
        );
    request.subscribe((data) => {
      this.diskProfile = data;
      this.alertService.info(
        `${isUpdate ? "Updated" : "Created"} ${this.diskProfile.name}`,
      );
      this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
    });
  }

  delete(): void {
    this.http
      .delete(
        `${this.env.e.url}/domain/cmdbDiskProfiles/${this.diskProfile.id}`,
      )
      .subscribe(() => {
        this.persisted.emit({ data: this.diskProfile, action: "deleted" });
        this.alertService.info(`Deleted ${this.diskProfile.name}`);
        if (!this.diskProfileId) {
          this.router.navigate(["/cmdbDiskProfiles"]);
        }
      });
  }

  onCheckboxChange(key: string, event: Event): void {
    const target = event.target as HTMLInputElement;
    this.diskProfile[key] = target.checked ? "Y" : "N";
  }

  onHostingPlatformChange(osType: any): void {
    this.selectedHostingPlatform = osType;
    this.hostingPlatformName = osType ? osType.name : "";
  }

  onOsVersionChange(status: any): void {
    this.selectedOsVersion = status;
    this.osVersionName = status ? status.name : "";
  }

  onOsDiskTypeChange(fileSystem: any): void {
    this.selectedOsDiskType = fileSystem;
    this.osDiskTypeName = fileSystem ? fileSystem.name : "";
  }

  onOsMountChange(mountType: any): void {
    this.selectedOsMount = mountType;
    this.osMountName = mountType ? mountType.name : "";
  }

  onStorageTierChange(storageTier: any): void {
    this.selectedStorageTier = storageTier;
    this.storageTierName = storageTier ? storageTier.name : "";
  }
}
